package br.com.texeratx.boardgametimeapp.data.model.stats

import kotlinx.serialization.Serializable

@Serializable
data class GameDurationStatsDTO(
    val gameId: Long,
    val name: String,
    val avgDuration: Double,
    val minDuration: Int,
    val maxDuration: Int,
    val count: Int
)

@Serializable
data class PlayerStatsDTO(
    val playerId: Long,
    val name: String,
    val nickname: String?,
    val imageUrl: String?,
    val wins: Int,
    val seconds: Int,
    val participations: Int,
    val winRate: Double,
    val secondRate: Double
)

@Serializable
data class RecentMatchDTO(
    val matchId: Long,
    val gameName: String,
    val gameImageUrl: String?,
    val date: String,
    val duration: Int,
    val players: List<String>
)

@Serializable
data class DashboardGameDTO(
    val gameId: Long,
    val name: String,
    val imageUrl: String?,
    val count: Int
)

@Serializable
data class CategoryStatsDTO(
    val categoryId: Long,
    val name: String,
    val count: Int
)

@Serializable
data class PlayerMinutesDTO(
    val playerId: Long,
    val name: String,
    val nickname: String? = null,
    val imageUrl: String? = null,
    val totalMinutes: Int
)

@Serializable
data class StatsOverviewDTO(
    val totalMinutes: Int,
    val gamesMostPlayed: List<DashboardGameDTO>,
    val playerStats: List<PlayerStatsDTO>,
    val categoriesMostPlayed: List<CategoryStatsDTO> = emptyList(),
    val playerMinutesRanking: List<PlayerMinutesDTO> = emptyList(),
    val uniqueGamesCount: Int = 0,
    val playerParticipationRanking: List<PlayerParticipationDTO> = emptyList(),
    val totalMatches: Int = 0
)

@Serializable
data class PlayerParticipationDTO(
    val playerId: Long,
    val name: String,
    val count: Int,
    val nickname: String? = null,
    val imageUrl: String? = null
)

@Serializable
data class PlayerWinsDTO(
    val playerId: Long,
    val name: String,
    val wins: Int,
    val winRate: Double = 0.0,
    val nickname: String? = null,
    val imageUrl: String? = null
)

@Serializable
data class YearHistoryDTO(
    val year: Int,
    val totalMatches: Int,
    val totalMinutes: Int,
    val mostPlayedGames: List<DashboardGameDTO>,
    val participationByPlayer: List<PlayerParticipationDTO>,
    val winsByPlayer: List<PlayerWinsDTO>,
    val matchesPerMonth: Map<Int, Int>,
    val categoriesMostPlayed: List<CategoryStatsDTO> = emptyList(),
    val playerMinutesRanking: List<PlayerMinutesDTO> = emptyList(),
    val uniqueGamesCount: Int = 0
)
